import m from '../../prime-src/prepare';

export default function ButtonsHead() {
  return (
    <header className="side2" id="head">
      <div className="button button-Go" onClick={() => m.$window.trigger({ type: 'keydown', code: 'KeyG' } as any)}>Fuzzy Search <span className="bold underline">G</span>o (FS)</div>
      <div className="button button-goto-cats" onClick={() => m.$window.trigger({ type: 'keydown', code: 'KeyC' } as any)}>Go to <span className="bold underline">C</span>ats</div>
      <div className="button button-mode button-neighbors-mode" onClick={() => m.$window.trigger({ type: 'keydown', code: 'KeyB' } as any)}>Neigh<span className="bold underline">b</span>ors mode</div>
      <div className="button button-mode button-multireco-mode" onClick={() => m.$window.trigger({ type: 'keydown', code: 'KeyM' } as any)}><span className="bold underline">M</span>ultireco mode</div>
      <div className="button button-new-reco" onClick={() => m.$window.trigger({ type: 'keydown', code: 'KeyN' } as any)}><span className="bold underline">N</span>ew reco</div>
    </header>
  );
}
